import { useMemo } from 'react';
import { sanitize } from 'dompurify';

export const useSanitize = (unsafeHtml) => useMemo(() => sanitize(unsafeHtml, { ADD_ATTR: ['target'] }), [unsafeHtml]);
